import { VideoComponent } from "./video/video.component";
import { CanvasedVideoComponent } from "./canvased-video/canvased-video.component";
import { PlainVideoComponent } from "./plain-video/plain-video.component";
import { AudioComponent } from "./audio/audio.component";

export {
  VideoComponent,
  CanvasedVideoComponent,
  PlainVideoComponent,
  AudioComponent
};

export default [
  VideoComponent,
  CanvasedVideoComponent,
  PlainVideoComponent,
  AudioComponent
];
